const paneller = [
  {
    "title": "TommaTech 425-400Wp 44PM Shingled Monofacial Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/208_tommatech-425-400wp-44pm-shingled-monofacial-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-44pm-shingled-monofacial-gunes-paneli-1851.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-44pm-shingled-monofacial-gunes-paneli-1850.html"
      },
      {
        "wp": "415 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-415wp-44pm-shingled-monofacial-gunes-paneli-1849.html"
      },
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-44pm-shingled-monofacial-gunes-paneli-1848.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-44pm-shingled-monofacial-gunes-paneli-1847.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-44pm-shingled-monofacial-gunes-paneli-1846.html"
      }
    ]
  },
  {
    "title": "TommaTech 445-420Wp 46PM Shingled Monofacial Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/209_tommatech-445-420wp-46pm-shingled-monofacial-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-46pm-shingled-monofacial-gunes-paneli-1857.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-46pm-shingled-monofacial-gunes-paneli-1856.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-435wp-46pm-shingled-monofacial-gunes-paneli-1855.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-430wp-46pm-shingled-monofacial-gunes-paneli-1854.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-46pm-shingled-monofacial-gunes-paneli-1853.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-46pm-shingled-monofacial-gunes-paneli-1852.html"
      }
    ]
  },
  {
    "title": "CW Enerji 635-615Wp M10 156TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/213_cw-enerji-635-615wp-m10-156tn-topcon-gunes-panelleri.jpg",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-635wp-156tn-m10-topcon-gunes-paneli-1895.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-630wp-156tn-m10-topcon-gunes-paneli-1896.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-625wp-156tn-m10-topcon-gunes-paneli-1897.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-156tn-m10-topcon-gunes-paneli-1898.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-156tn-m10-topcon-gunes-paneli-1899.html"
      }
    ]
  },
  {
    "title": "TommaTech 575-555Wp M12 108TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/214_tommatech-575-555wp-m12-108tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-575wp-108tn-m12-topcon-gunes-paneli-1908.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-570wp-108tn-m12-topcon-gunes-paneli-1907.html"
      },
      {
        "wp": "565 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-565wp-108tn-m12-topcon-gunes-paneli-1906.html"
      },
      {
        "wp": "560 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-560wp-108tn-m12-topcon-gunes-paneli-1905.html"
      },
      {
        "wp": "555 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-555wp-108tn-m12-topcon-gunes-paneli-1904.html"
      }
    ]
  },
  {
    "title": "TommaTech 575-555Wp M12 108TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/215_tommatech-575-555wp-m12-108tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-575wp-108tnb-m12-topcon-gunes-paneli-1913.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-570wp-108tnb-m12-topcon-gunes-paneli-1912.html"
      },
      {
        "wp": "565 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-565wp-108tnb-m12-topcon-gunes-paneli-1911.html"
      },
      {
        "wp": "560 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-560wp-108tnb-m12-topcon-gunes-paneli-1910.html"
      },
      {
        "wp": "555 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-555wp-108tnb-m12-topcon-gunes-paneli-1909.html"
      }
    ]
  },
  {
    "title": "TommaTech 535-510Wp M12 108TNBR TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/216_tommatech-535-510wp-m12-108tnbr-topcon-gunes-panelleri.jpg",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-108tnbr-m12-g2g-topcon-gunes-paneli-1919.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-108tnbr-m12-g2g-topcon-gunes-paneli-1918.html"
      },
      {
        "wp": "525 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-525wp-108tnbr-m12-g2g-topcon-gunes-paneli-1917.html"
      },
      {
        "wp": "520 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-520wp-108tnbr-m12-g2g-topcon-gunes-paneli-1916.html"
      },
      {
        "wp": "515 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-515wp-108tnbr-m12-g2g-topcon-gunes-paneli-1915.html"
      },
      {
        "wp": "510 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-510wp-108tnbr-m12-g2g-topcon-gunes-paneli-1914.html"
      }
    ]
  },
  {
    "title": "TommaTech 645-615Wp M12 120TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/217_tommatech-645-615wp-m12-120tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-645wp-120tn-m12-topcon-gunes-paneli-1926.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-640wp-120tn-m12-topcon-gunes-paneli-1928.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-635wp-120tn-m12-topcon-gunes-paneli-1925.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-630wp-120tn-m12-topcon-gunes-paneli-1924.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-625wp-120tn-m12-topcon-gunes-paneli-1923.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-620wp-120tn-m12-topcon-gunes-paneli-1922.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-615wp-120tn-m12-topcon-gunes-paneli-1921.html"
      }
    ]
  },
  {
    "title": "TommaTech 645-615Wp M12 120TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/218_tommatech-645-615wp-m12-120tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-645wp-120tnb-m12-topcon-gunes-paneli-1942.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-640wp-120tnb-m12-topcon-gunes-paneli-1940.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-635wp-120tnb-m12-topcon-gunes-paneli-1936.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-630wp-120tnb-m12-topcon-gunes-paneli-1935.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-625wp-120tnb-m12-topcon-gunes-paneli-1934.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-620wp-120tnb-m12-topcon-gunes-paneli-1933.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-615wp-120tnb-m12-topcon-gunes-paneli-1932.html"
      }
    ]
  },
  {
    "title": "CW Enerji 455-420Wp M10 108TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/130_cw-enerji-450-435wp-m10-108tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-455wp-108tn-m10-topcon-gunes-paneli-1877.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-450wp-108tn-m10-topcon-gunes-paneli-1749.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-445wp-108tn-m10-topcon-gunes-paneli-1748.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-440wp-108tn-m10-topcon-gunes-paneli-1335.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-435wp-108tn-m10-topcon-gunes-paneli-1330.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-430wp-108tn-m10-topcon-gunes-paneli-1331.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-425wp-108tn-m10-topcon-gunes-paneli-1332.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-420wp-108tn-m10-topcon-gunes-paneli-1882.html"
      }
    ]
  },
  {
    "title": "CW Enerji 450-435Wp M10 108TNFB TOPCon Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/131_cw-enerji-435-415wp-m10-108tnfb-topcon-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-450wp-108tnfb-m10-topcon-black-series-gunes-paneli-1338.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-445wp-108tnfb-m10-topcon-black-series-gunes-paneli-1340.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-440wp-108tnfb-m10-topcon-black-series-gunes-paneli-1341.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-435wp-108tnfb-m10-topcon-black-series-gunes-paneli-1337.html"
      }
    ]
  },
  {
    "title": "CW Enerji 455-420Wp M10 108TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/158_cw-enerji-450-435wp-m10-108tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-455wp-108tnb-m10-topcon-gunes-paneli-1900.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-450wp-108tnb-m10-topcon-gunes-paneli-1516.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-445wp-108tnb-m10-topcon-gunes-paneli-1515.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-440wp-108tnb-m10-topcon-gunes-paneli-1514.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-435wp-108tnb-m10-topcon-gunes-paneli-1513.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-425wp-108tnb-m10-topcon-gunes-paneli-1901.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-420wp-108tnb-m10-topcon-gunes-paneli-1902.html"
      }
    ]
  },
  {
    "title": "CW Enerji 480-460Wp M10 120TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/115_cw-enerji-480-460wp-m10-120tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "480 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-480wp-120tn-m10-topcon-gunes-paneli-1290.html"
      },
      {
        "wp": "475 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-475wp-120tn-m10-topcon-gunes-paneli-1291.html"
      },
      {
        "wp": "470 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-470wp-120tn-m10-topcon-gunes-paneli-1292.html"
      },
      {
        "wp": "465 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-465wp-120tn-m10-topcon-gunes-paneli-1293.html"
      },
      {
        "wp": "460 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-460wp-120tn-m10-topcon-gunes-paneli-1294.html"
      }
    ]
  },
  {
    "title": "CW Enerji 480-460Wp M10 120TNFB TOPCon Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/149_cw-enerji-480-460wp-m10-120tnfb-topcon-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "480 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-480wp-120tnfb-m10-topcon-black-series-gunes-paneli-1411.html"
      },
      {
        "wp": "475 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-475wp-120tnfb-m10-topcon-black-series-gunes-paneli-1410.html"
      },
      {
        "wp": "470 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-470wp-120tnfb-m10-topcon-black-series-gunes-paneli-1409.html"
      },
      {
        "wp": "465 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-465wp-120tnfb-m10-topcon-black-series-gunes-paneli-1408.html"
      },
      {
        "wp": "460 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-460wp-120tnfb-m10-topcon-black-series-gunes-paneli-1407.html"
      }
    ]
  },
  {
    "title": "CW Enerji 620-590Wp M10 144TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/116_cw-enerji-595-570wp-m10-144tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-144tn-m10-topcon-gunes-paneli-1295.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-144tn-m10-topcon-gunes-paneli-1298.html"
      },
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-144tn-m10-topcon-gunes-paneli-1628.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-144tn-m10-topcon-gunes-paneli-1299.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-144tn-m10-topcon-gunes-paneli-1300.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-144tn-m10-topcon-gunes-paneli-1296.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-144tn-m10-topcon-gunes-paneli-1883.html"
      }
    ]
  },
  {
    "title": "CW Enerji 605-585Wp M10 144TNFB TOPCon Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/132_cw-enerji-595-570wp-m10-144tnfb-topcon-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-144tnfb-m10-topcon-black-series-gunes-paneli-1344.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-144tnfb-m10-topcon-black-series-gunes-paneli-1342.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-144tnfb-m10-topcon-black-series-gunes-paneli-1629.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-144tnfb-m10-topcon-black-series-gunes-paneli-1346.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-585wp-144tnfb-m10-topcon-black-series-gunes-paneli-1345.html"
      }
    ]
  },
  {
    "title": "CW Enerji 620-590Wp M10 144TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/157_cw-enerji-595-570wp-m10-144tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-144tnb-m10-topcon-gunes-paneli-1507.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-144tnb-m10-topcon-gunes-paneli-1510.html"
      },
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-144tnb-m10-topcon-gunes-paneli-1630.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-144tnb-m10-topcon-gunes-paneli-1756.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-144tnb-m10-topcon-gunes-paneli-1755.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-144tnb-m10-topcon-gunes-paneli-1508.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-144tnb-m10-topcon-gunes-paneli-1511.html"
      }
    ]
  },
  {
    "title": "CW Enerji 620-590Wp M10 144TNB G2G TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/172_cw-enerji-580-560wp-m10-144tnb-g2g-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-144tnb-m10-g2g-topcon-gunes-paneli-1886.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-144tnb-m10-g2g-topcon-gunes-paneli-1885.html"
      },
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-144tnb-m10-g2g-topcon-gunes-paneli-1582.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-144tnb-m10-g2g-topcon-gunes-paneli-1581.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-144tnb-m10-g2g-topcon-gunes-paneli-1580.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-144tnb-m10-g2g-topcon-gunes-paneli-1578.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-144tnb-m10-g2g-topcon-gunes-paneli-1579.html"
      }
    ]
  },
  {
    "title": "CW Enerji 655-620Wp M12 132TNR TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/210_cw-enerji-655-620wp-m12-132tnr-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655wp-132tnr-m12-topcon-gunes-paneli-1870.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650wp-132tnr-m12-topcon-gunes-paneli-1869.html"
      },
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-645wp-132tnr-m12-topcon-gunes-paneli-1868.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-640wp-132tnr-m12-topcon-gunes-paneli-1867.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-635wp-132tnr-m12-topcon-gunes-paneli-1866.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-630wp-132tnr-m12-topcon-gunes-paneli-1865.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-625wp-132tnr-m12-topcon-gunes-paneli-1864.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-132tnr-m12-topcon-gunes-paneli-1863.html"
      }
    ]
  },
  {
    "title": "CW Enerji 535-510Wp M12 108TNBR TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/195_cw-enerji-535-510wp-m12-108tnbr-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108tnbr-m12-g2g-topcon-gunes-paneli-1815.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108tnbr-m12-g2g-topcon-gunes-paneli-1814.html"
      },
      {
        "wp": "525 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-525wp-108tnbr-m12-g2g-topcon-gunes-paneli-1813.html"
      },
      {
        "wp": "520 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-520wp-108tnbr-m12-g2g-topcon-gunes-paneli-1812.html"
      },
      {
        "wp": "515 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-515wp-108tnbr-m12-g2g-topcon-gunes-paneli-1811.html"
      },
      {
        "wp": "510 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-510wp-108tnbr-m12-g2g-topcon-gunes-paneli-1810.html"
      }
    ]
  },
  {
    "title": "CW Enerji 755-715Wp M12 132TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/187_cw-enerji-715-680wp-m12-132tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "755 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-755wp-132tnb-m12-topcon-gunes-paneli-1225.html"
      },
      {
        "wp": "750 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-750wp-132tnb-m12-topcon-gunes-paneli-1702.html"
      },
      {
        "wp": "745 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-745wp-132tnb-m12-topcon-gunes-paneli-1701.html"
      },
      {
        "wp": "740 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-740wp-132tnb-m12-topcon-gunes-paneli-1700.html"
      },
      {
        "wp": "735 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-735wp-132tnb-m12-topcon-gunes-paneli-1699.html"
      },
      {
        "wp": "730 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-730wp-132tnb-m12-topcon-gunes-paneli-1698.html"
      },
      {
        "wp": "725 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-725wp-132tnb-m12-topcon-gunes-paneli-1697.html"
      },
      {
        "wp": "720 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-720wp-132tnb-m12-topcon-gunes-paneli-1696.html"
      },
      {
        "wp": "715 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-715wp-132tnb-m12-topcon-gunes-paneli-1703.html"
      }
    ]
  },
  {
    "title": "CW Enerji 645-615Wp M12 120TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/183_cw-enerji-645-615wp-m12-120tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-645wp-120tn-m12-topcon-gunes-paneli-1667.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-640wp-120tn-m12-topcon-gunes-paneli-1666.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-635wp-120tn-m12-topcon-gunes-paneli-1665.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-630wp-120tn-m12-topcon-gunes-paneli-1664.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-625wp-120tn-m12-topcon-gunes-paneli-1663.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-120tn-m12-topcon-gunes-paneli-1662.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-120tn-m12-topcon-gunes-paneli-1661.html"
      }
    ]
  },
  {
    "title": "CW Enerji 645-615Wp M12 120TNB Topcon N-Type Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/184_cw-enerji-645-615wp-m12-120tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-645wp-120tnb-m12-topcon-gunes-paneli-1674.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-640wp-120tnb-m12-topcon-gunes-paneli-1673.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-635wp-120tnb-m12-topcon-gunes-paneli-1672.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-630wp-120tnb-m12-topcon-gunes-paneli-1671.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-625wp-120tnb-m12-topcon-gunes-paneli-1670.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-120tnb-m12-topcon-gunes-paneli-1669.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-120tnb-m12-topcon-gunes-paneli-1668.html"
      }
    ]
  },
  {
    "title": "CW Enerji 645-615Wp M12 120TNB G2G TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/185_cw-enerji-645-615wp-m12-120tnb-g2g-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-645wp-120tnb-m12-g2g-topcon-gunes-paneli-1686.html"
      },
      {
        "wp": "640 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-640wp-120tnb-m12-g2g-topcon-gunes-paneli-1684.html"
      },
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-635wp-120tnb-m12-g2g-topcon-gunes-paneli-1681.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-630wp-120tnb-m12-g2g-topcon-gunes-paneli-1678.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-625wp-120tnb-m12-g2g-topcon-gunes-paneli-1677.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-620wp-120tnb-m12-g2g-topcon-gunes-paneli-1676.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-615wp-120tnb-m12-g2g-topcon-gunes-paneli-1675.html"
      }
    ]
  },
  {
    "title": "CW Enerji 575-555Wp M12 108TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/180_cw-enerji-575-555wp-m12-108tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-108tn-m12-topcon-gunes-paneli-1641.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-570wp-108tn-m12-topcon-gunes-paneli-1640.html"
      },
      {
        "wp": "565 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-565wp-108tn-m12-topcon-gunes-paneli-1639.html"
      },
      {
        "wp": "560 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-560wp-108tn-m12-topcon-gunes-paneli-1638.html"
      },
      {
        "wp": "555 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-555wp-108tn-m12-topcon-gunes-paneli-1637.html"
      }
    ]
  },
  {
    "title": "CW Enerji 575-555Wp M12 108TNB Topcon N-Type Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/181_cw-enerji-575-555wp-m12-108tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-108tnb-m12-topcon-gunes-paneli-1646.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-570wp-108tnb-m12-topcon-gunes-paneli-1645.html"
      },
      {
        "wp": "565 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-565wp-108tnb-m12-topcon-gunes-paneli-1644.html"
      },
      {
        "wp": "560 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-560wp-108tnb-m12-topcon-gunes-paneli-1643.html"
      },
      {
        "wp": "555 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-555wp-108tnb-m12-topcon-gunes-paneli-1642.html"
      }
    ]
  },
  {
    "title": "CW Enerji 575-555Wp M12 108TNB G2G TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/182_cw-enerji-575-555wp-m12-108tnb-g2g-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-108tnb-m12-g2g-topcon-gunes-paneli-1652.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-570wp-108tnb-m12-g2g-topcon-gunes-paneli-1651.html"
      },
      {
        "wp": "565 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-565wp-108tnb-m12-g2g-topcon-gunes-paneli-1649.html"
      },
      {
        "wp": "560 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-560wp-108tnb-m12-g2g-topcon-gunes-paneli-1648.html"
      },
      {
        "wp": "555 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-555wp-108tnb-m12-g2g-topcon-gunes-paneli-1647.html"
      }
    ]
  },
  {
    "title": "CW Enerji 390-260Wp BIPV Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/140_cw-enerji-390-260wp-bipv-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam",
    "variants": [
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-390wp-78pm-bipv-gunes-paneli-1367.html"
      },
      {
        "wp": "325 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-325wp-65pm-bipv-gunes-paneli-1366.html"
      },
      {
        "wp": "260 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-260wp-52pm-bipv-gunes-paneli-1360.html"
      }
    ]
  },
  {
    "title": "CW Enerji 675-650Wp M12 132PM Black&White Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/112_cw-enerji-675-650wp-m12-132pm-blackwhite-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-675-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1278.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-670-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1277.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-665-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1276.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-660-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1275.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1274.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650-wp-132pm-m12-blackwhite-gunes-paneli-serisi-1273.html"
      }
    ]
  },
  {
    "title": "CW Enerji 675-650Wp M12 132PMBS HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/114_cw-enerji-675-650wp-m12-132pmbs-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-675-wp-132pmbs-m12-hc-mb-gunes-paneli-1289.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-670-wp-132pmbs-m12-hc-mb-gunes-paneli-1288.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-665-wp-132pmbs-m12-hc-mb-gunes-paneli-1287.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-660-wp-132pmbs-m12-hc-mb-gunes-paneli-1286.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655-wp-132pmbs-m12-hc-mb-gunes-paneli-1285.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650-wp-132pmbs-m12-hc-mb-gunes-paneli-1284.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 132PM Black&White Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/113_cw-enerji-550-530wp-m12-132pm-blackwhite-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550-wp-108pm-m12-blackwhite-gunes-paneli-serisi-1283.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545-wp-108pm-m12-blackwhite-gunes-paneli-serisi-1282.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540-wp-108pm-m12-blackwhite-gunes-paneli-serisi-1281.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535-wp-108pm-m12-blackwhite-gunes-paneli-serisi-1280.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530-wp-108pm-m12-blackwhite-gunes-paneli-serisi-1279.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 108PM HC-MB Çatı Kiremidi Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/139_cw-enerji-550-530wp-m12-108pm-hc-mb-cati-kiremidi-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-108pm-m12-hc-mb-cati-kiremidi-1365.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-108pm-m12-hc-mb-cati-kiremidi-1364.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-108pm-m12-hc-mb-cati-kiremidi-1363.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108pm-m12-hc-mb-cati-kiremidi-1362.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108pm-m12-hc-mb-cati-kiremidi-1361.html"
      }
    ]
  },
  {
    "title": "CW Enerji 595-570Wp 144TNCK10 HC-MB Çatı Kiremidi TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/167_cw-enerji-595-570wp-144tnck10-hc-mb-cati-kiremidi-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n10 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-144tnck10-hc-mb-topcon-cati-kiremidi-1717.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-144tnck10-hc-mb-topcon-cati-kiremidi-1554.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-585wp-144tnck10-hc-mb-topcon-cati-kiremidi-1553.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-580wp-144tnck10-hc-mb-topcon-cati-kiremidi-1552.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-144tnck10-hc-mb-topcon-cati-kiremidi-1551.html"
      },
      {
        "wp": "570 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-570wp-144tnck10-hc-mb-topcon-cati-kiremidi-1550.html"
      }
    ]
  },
  {
    "title": "CW Enerji 610-590Wp M12 120PM Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/174_cw-enerji-610-590wp-m12-120pm-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-120pm-m12-black-series-gunes-paneli-1592.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-120pm-m12-black-series-gunes-paneli-1591.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-120pm-m12-black-series-gunes-paneli-1590.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-120pm-m12-black-series-gunes-paneli-1589.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-120pm-m12-black-series-gunes-paneli-1588.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M10 144PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/173_cw-enerji-550-530wp-m10-144pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-144pmb-m10-hc-mb-gunes-paneli-1583.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-144pmb-m10-hc-mb-gunes-paneli-1584.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-144pmb-m10-hc-mb-gunes-paneli-1585.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-144pmb-m10-hc-mb-gunes-paneli-1586.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-144pmb-m10-hc-mb-gunes-paneli-1587.html"
      }
    ]
  },
  {
    "title": "CW Enerji 675-650Wp M12 132PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/24_cw-enerji-675-650wp-m12-132pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-675wp-132pm-m12-hc-mb-gunes-paneli-772.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-670wp-132pm-m12-hc-mb-gunes-paneli-773.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-665wp-132pm-m12-hc-mb-gunes-paneli-774.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-660wp-132pm-m12-hc-mb-gunes-paneli-775.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655wp-132pm-m12-hc-mb-gunes-paneli-776.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650wp-132pm-m12-hc-mb-gunes-paneli-777.html"
      }
    ]
  },
  {
    "title": "CW Enerji 610-590Wp M12 120PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/22_cw-enerji-610-590wp-m12-120pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-120pmb-m12-hc-mb-g2g-gunes-paneli-778.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-120pmb-m12-hc-mb-g2g-gunes-paneli-779.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-120pmb-m12-hc-mb-g2g-gunes-paneli-780.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595-wp-120pmb-m12-hc-mb-g2g-gunes-paneli-781.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-120pmb-m12-hc-mb-g2g-gunes-paneli-782.html"
      }
    ]
  },
  {
    "title": "CW Enerji 610-590Wp M12 120PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/20_cw-enerji-610-590wp-m12-120pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-120pm-m12-hc-mb-gunes-paneli-762.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-120pm-m12-hc-mb-gunes-paneli-763.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-120pm-m12-hc-mb-gunes-paneli-764.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-120pm-m12-hc-mb-gunes-paneli-765.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-120pm-m12-hc-mb-gunes-paneli-766.html"
      }
    ]
  },
  {
    "title": "CW Enerji 610-590Wp M12 120PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/21_cw-enerji-610-590wp-m12-120pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-610wp-120pmb-m12-hc-mb-gunes-paneli-767.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-605wp-120pmb-m12-hc-mb-gunes-paneli-768.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-600wp-120pmb-m12-hc-mb-gunes-paneli-769.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-120pmb-m12-hc-mb-gunes-paneli-770.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-120pmb-m12-hc-mb-gunes-paneli-771.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 108PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/17_cw-enerji-550-530wp-m12-108pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-108pmb-m12-hc-mb-g2g-gunes-paneli-1172.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-108pmb-m12-hc-mb-g2g-gunes-paneli-1171.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-108pmb-m12-hc-mb-g2g-gunes-paneli-1170.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108pmb-m12-hc-mb-g2g-gunes-paneli-1169.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108pmb-m12-hc-mb-g2g-gunes-paneli-1168.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 108PMBS HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/16_cw-enerji-550-530wp-m12-108pmbs-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-108pmb-m12-hc-mb-gunes-paneli-1160.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-108pmb-m12-hc-mb-gunes-paneli-1159.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-108pmb-m12-hc-mb-gunes-paneli-1158.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108pmb-m12-hc-mb-gunes-paneli-1157.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108pmb-m12-hc-mb-gunes-paneli-1156.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 108PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/15_cw-enerji-550-530wp-m12-108pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-108pm-m12-hc-mb-gunes-paneli-831.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-108pm-m12-hc-mb-gunes-paneli-832.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-108pm-m12-hc-mb-gunes-paneli-833.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108pm-m12-hc-mb-gunes-paneli-834.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108pm-m12-hc-mb-gunes-paneli-835.html"
      }
    ]
  },
  {
    "title": "CW Enerji 405-385Wp M12 120PM-F TC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/19_cw-enerji-405-385wp-m12-120pm-f-tc-mb-gunes-paneli-serisi.webp",
    "text": "Multi Busbar Teknolojisi\nOn-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-405wp-120pm-f-m12-tc-mb-gunes-paneli-894.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-400wp-120pm-f-m12-tc-mb-gunes-paneli-890.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-395wp-120pm-f-m12-tc-mb-gunes-paneli-889.html"
      },
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-390wp-120pm-f-m12-tc-mb-gunes-paneli-888.html"
      },
      {
        "wp": "385 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-385wp-120pm-f-m12-tc-mb-gunes-paneli-887.html"
      }
    ]
  },
  {
    "title": "CW Enerji 405-385Wp M12 80PM-F HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/14_cw-enerji-405-385wp-m12-80pm-f-hc-mb-gunes-paneli-serisi.webp",
    "text": "Multi Busbar Teknolojisi\nOn-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-405wp-80pm-f-m12-hc-mb-gunes-paneli-881.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-400wp-80pm-f-m12-hc-mb-gunes-paneli-880.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-395wp-80pm-f-m12-hc-mb-gunes-paneli-879.html"
      },
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-390wp-80pm-f-m12-hc-mb-gunes-paneli-878.html"
      },
      {
        "wp": "385 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-385wp-80pm-f-m12-hc-mb-gunes-paneli-877.html"
      }
    ]
  },
  {
    "title": "CW Enerji 595-575Wp M10 156PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/12_cw-enerji-595-575wp-m10-156pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-156pm-m10-hc-mb-gunes-paneli-836.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-156pm-m10-hc-mb-gunes-paneli-837.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-585wp-156pm-m10-hc-mb-gunes-paneli-838.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-580wp-156pm-m10-hc-mb-gunes-paneli-839.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-156pm-m10-hc-mb-gunes-paneli-1796.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M10 144PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/10_cw-enerji-550-530wp-m10-144pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-144pmb-m10-hc-mb-g2g-gunes-paneli-757.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-144pmb-m10-hc-mb-g2g-gunes-paneli-758.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-144pmb-m10-hc-mb-g2g-gunes-paneli-759.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-144pmb-m10-hc-mb-g2g-gunes-paneli-760.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-144pmb-m10-hc-mb-g2g-gunes-paneli-761.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M10 144PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/9_cw-enerji-550-530wp-m10-144pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-144pm-m10-hc-mb-gunes-paneli-752.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-144pm-m10-hc-mb-gunes-paneli-753.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-144pm-m10-hc-mb-gunes-paneli-754.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-144pm-m10-hc-mb-gunes-paneli-755.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-144pm-m10-hc-mb-gunes-paneli-756.html"
      }
    ]
  },
  {
    "title": "CW Enerji 410-395Wp M10 108PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/7_cw-enerji-410-395wp-m10-108pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-410wp-108pm-m10-hc-mb-gunes-paneli-955.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-405wp-108pm-m10-hc-mb-gunes-paneli-954.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-400wp-108pm-m10-hc-mb-gunes-paneli-953.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-395wp-108pm-m10-hc-mb-gunes-paneli-952.html"
      }
    ]
  },
  {
    "title": "CW Enerji 675-650Wp M12 132PMFB Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/26_cw-enerji-675-650wp-m12-132pmfb-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-675wp-132pmfb-m12-black-series-gunes-paneli-1042.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-670wp-132pmfb-m12-black-series-gunes-paneli-1041.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-665wp-132pmfb-m12-black-series-gunes-paneli-1040.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-660wp-132pmfb-m12-black-series-gunes-paneli-1039.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655wp-132pmfb-m12-black-series-gunes-paneli-1038.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650wp-132pmfb-m12-black-series-gunes-paneli-1037.html"
      }
    ]
  },
  {
    "title": "CW Enerji 595-575Wp M10 156PM HC-MB Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/13_cw-enerji-595-575wp-m10-156pm-hc-mb-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-595wp-156pm-m10-black-series-gunes-paneli-1023.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-590wp-156pm-m10-black-series-gunes-paneli-1022.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-585wp-156pm-m10-black-series-gunes-paneli-1018.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-580wp-156pm-m10-black-series-gunes-paneli-1015.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-575wp-156pm-m10-black-series-gunes-paneli-1012.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M10 144PM Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/11_cw-enerji-550-530wp-m10-144pm-black-series-gunes-paneli.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-144pm-m10-black-series-gunes-paneli-1009.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-144pm-m10-black-series-gunes-paneli-1006.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-144pm-m10-black-series-gunes-paneli-1004.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-144pm-m10-black-series-gunes-paneli-1002.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-144pm-m10-black-series-gunes-paneli-1000.html"
      }
    ]
  },
  {
    "title": "CW Enerji 550-530Wp M12 108PMFB Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/18_cw-enerji-550-530wp-m12-108pmfb-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-550wp-108pmfb-m12-black-series-gunes-paneli-1034.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-545wp-108pmfb-m12-black-series-gunes-paneli-1032.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-540wp-108pmfb-m12-black-series-gunes-paneli-1029.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-535wp-108pmfb-m12-black-series-gunes-paneli-1028.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-530wp-108pmfb-m12-black-series-gunes-paneli-1027.html"
      }
    ]
  },
  {
    "title": "CW Enerji 410-395Wp M10 108PM Black Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/8_cw-enerji-410-395wp-m10-108pm-black-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-410wp-108pm-m10-black-series-gunes-paneli-951.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-405wp-108pm-m10-black-series-gunes-paneli-950.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-400wp-108pm-m10-black-series-gunes-paneli-949.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-395wp-108pm-m10-black-series-gunes-paneli-948.html"
      }
    ]
  },
  {
    "title": "CW Enerji 675-650Wp M12 132PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/25_cw-enerji-675-650wp-m12-132pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "On-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-675wp-132pmb-m12-hc-mb-g2g-gunes-paneli-783.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-670wp-132pmb-m12-hc-mb-g2g-gunes-paneli-784.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-665wp-132pmb-m12-hc-mb-g2g-gunes-paneli-785.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-660wp-132pmb-m12-hc-mb-g2g-gunes-paneli-786.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-655wp-132pmb-m12-hc-mb-g2g-gunes-paneli-787.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/cw-enerji-650wp-132pmb-m12-hc-mb-g2g-gunes-paneli-788.html"
      }
    ]
  },
  {
    "title": "TommaTech 410-395Wp M10 108PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/30_tommatech-410-395wp-m10-108pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-108pm-m10-hc-mb-gunes-paneli-947.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-108pm-m10-hc-mb-gunes-paneli-946.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-108pm-m10-hc-mb-gunes-paneli-945.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-108pm-m10-hc-mb-gunes-paneli-944.html"
      }
    ]
  },
  {
    "title": "TommaTech 410-395Wp M10 108PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/32_tommatech-410-395wp-m10-108pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-108pm-m10-dark-series-gunes-paneli-927.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-108pm-m10-dark-series-gunes-paneli-926.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-108pm-m10-dark-series-gunes-paneli-925.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-108pm-m10-dark-series-gunes-paneli-924.html"
      }
    ]
  },
  {
    "title": "TommaTech 410-395Wp M10 108PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/193_tommatech-410-395wp-m10-108pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-108pmb-m10-hc-mb-gunes-paneli-1786.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-108pmb-m10-hc-mb-gunes-paneli-1789.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-108pmb-m10-hc-mb-gunes-paneli-1787.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-108pmb-m10-hc-mb-gunes-paneli-1788.html"
      }
    ]
  },
  {
    "title": "TommaTech 415-405Wp M10 108PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/31_tommatech-415-405wp-m10-108pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "415 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-415wp-108pmb-m10-hc-mb-g2g-gunes-paneli-1198.html"
      },
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-108pmb-m10-hc-mb-g2g-gunes-paneli-1197.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-108pmb-m10-hc-mb-g2g-gunes-paneli-1196.html"
      }
    ]
  },
  {
    "title": "TommaTech 410-395Wp M10 108PM Black&White Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/33_tommatech-410-395wp-m10-108pm-blackwhite-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-108pm-m10-blackwhite-gunes-paneli-1212.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-108pm-m10-blackwhite-gunes-paneli-1214.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-108pm-m10-blackwhite-gunes-paneli-1213.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-108pm-m10-blackwhite-gunes-paneli-1215.html"
      }
    ]
  },
  {
    "title": "TommaTech 455-440Wp M10 120PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/34_tommatech-455-440wp-m10-120pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-455wp-120pm-m10-dark-series-gunes-paneli-1190.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-450wp-120pm-m10-dark-series-gunes-paneli-1189.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-120pm-m10-dark-series-gunes-paneli-1188.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-120pm-m10-dark-series-gunes-paneli-1187.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M10 144PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/35_tommatech-550-530wp-m10-144pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-144pm-m10-hc-mb-gunes-paneli-725.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-144pm-m10-hc-mb-gunes-paneli-726.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-144pm-m10-hc-mb-gunes-paneli-727.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-144pm-m10-hc-mb-gunes-paneli-728.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-144pm-m10-hc-mb-gunes-paneli-729.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M10 144PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/37_tommatech-550-530wp-m10-144pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Malzeme Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-144pm-m10-dark-series-gunes-paneli-995.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-144pm-m10-dark-series-gunes-paneli-994.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-144pm-m10-dark-series-gunes-paneli-993.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-144pm-m10-dark-series-gunes-paneli-992.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-144pm-m10-dark-series-gunes-paneli-991.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M10 144PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/194_tommatech-550-530wp-m10-144pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-144pmb-m10-hc-mb-gunes-paneli-1794.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-144pmb-m10-hc-mb-gunes-paneli-1793.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-144pmb-m10-hc-mb-gunes-paneli-1792.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-144pmb-m10-hc-mb-gunes-paneli-1791.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-144pmb-m10-hc-mb-gunes-paneli-1790.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M10 144PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/36_tommatech-550-530wp-m10-144pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-144pmb-m10-hc-mb-g2g-gunes-paneli-821.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-144pmb-m10-hc-mb-g2g-gunes-paneli-822.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-144pmb-m10-hc-mb-g2g-gunes-paneli-823.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-144pmb-m10-hc-mb-g2g-gunes-paneli-824.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-144pmb-m10-hc-mb-g2g-gunes-paneli-825.html"
      }
    ]
  },
  {
    "title": "TommaTech 595-575Wp M10 156PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/38_tommatech-595-575wp-m10-156pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-156pm-m10-hc-mb-gunes-paneli-841.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-156pm-m10-hc-mb-gunes-paneli-842.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-156pm-m10-hc-mb-gunes-paneli-843.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-580wp-156pm-m10-hc-mb-gunes-paneli-844.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-575wp-156pm-m10-hc-mb-gunes-paneli-845.html"
      }
    ]
  },
  {
    "title": "TommaTech 595-575Wp M10 156PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/39_tommatech-595-575wp-m10-156pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Malzeme Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-156pm-m10-dark-series-gunes-paneli-1001.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-156pm-m10-dark-series-gunes-paneli-999.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-156pm-m10-dark-series-gunes-paneli-998.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-580wp-156pm-m10-dark-series-gunes-paneli-997.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-575wp-156pm-m10-dark-series-gunes-paneli-996.html"
      }
    ]
  },
  {
    "title": "TommaTech 595-575Wp M10 156PM Black&White Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/192_tommatech-595-575wp-m10-156pm-blackwhite-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-156pm-m10-blackwhite-gunes-paneli-1781.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-156pm-m10-blackwhite-gunes-paneli-1782.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-156pm-m10-blackwhite-gunes-paneli-1783.html"
      },
      {
        "wp": "580 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-580wp-156pm-m10-blackwhite-gunes-paneli-1784.html"
      },
      {
        "wp": "575 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-575wp-156pm-m10-blackwhite-gunes-paneli-1785.html"
      }
    ]
  },
  {
    "title": "TommaTech 455-420Wp M10 108TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/150_tommatech-435-415wp-m10-108tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-455wp-108tn-m10-topcon-gunes-paneli-1859.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-450wp-108tn-m10-topcon-gunes-paneli-1746.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-108tn-m10-topcon-gunes-paneli-1412.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-108tn-m10-topcon-gunes-paneli-1413.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-435wp-108tn-m10-topcon-gunes-paneli-1415.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-430wp-108tn-m10-topcon-gunes-paneli-1414.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-108tn-m10-topcon-gunes-paneli-1378.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-108tn-m10-topcon-gunes-paneli-1770.html"
      }
    ]
  },
  {
    "title": "TommaTech 450-415Wp M10 108TNFB TopCon Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/151_tommatech-450-415wp-m10-108tnfb-topcon-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-450wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1416.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1417.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1418.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-435wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1420.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-430wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1419.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1750.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1751.html"
      },
      {
        "wp": "415 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-415wp-108tnfb-m10-topcon-dark-series-gunes-paneli-1752.html"
      }
    ]
  },
  {
    "title": "TommaTech 455-420Wp M10 108TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/155_tommatech-435-415wp-m10-108tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-455wp-108tnb-m10-topcon-gunes-paneli-1871.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-450wp-108tnb-m10-topcon-gunes-paneli-1498.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-108tnb-m10-topcon-gunes-paneli-1497.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-108tnb-m10-topcon-gunes-paneli-1500.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-435wp-108tnb-m10-topcon-gunes-paneli-1501.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-430wp-108tnb-m10-topcon-gunes-paneli-1772.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-108tnb-m10-topcon-gunes-paneli-1499.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-108tnb-m10-topcon-gunes-paneli-1773.html"
      }
    ]
  },
  {
    "title": "TommaTech 455-420Wp M10 108TNB TOPCon G2G Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/178_tommatech-435-415wp-m10-108tnb-topcon-g2g-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n​​​​​​​İki Katman Eva Lamineli Çift Cam\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "455 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-455wp-108tnb-m10-g2g-topcon-gunes-paneli-1881.html"
      },
      {
        "wp": "450 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-450wp-108tnb-m10-g2g-topcon-gunes-paneli-1880.html"
      },
      {
        "wp": "445 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-445wp-108tnb-m10-g2g-topcon-gunes-paneli-1879.html"
      },
      {
        "wp": "440 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-440wp-108tnb-m10-g2g-topcon-gunes-paneli-1878.html"
      },
      {
        "wp": "435 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-435wp-108tnb-m10-g2g-topcon-gunes-paneli-1685.html"
      },
      {
        "wp": "430 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-430wp-108tnb-m10-g2g-topcon-gunes-paneli-1683.html"
      },
      {
        "wp": "425 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-425wp-108tnb-m10-g2g-topcon-gunes-paneli-1682.html"
      },
      {
        "wp": "420 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-420wp-108tnb-m10-g2g-topcon-gunes-paneli-1680.html"
      }
    ]
  },
  {
    "title": "TommaTech 480-460Wp M10 120TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/117_tommatech-480-460wp-m10-120tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "480 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-480wp-120tn-m10-topcon-gunes-paneli-1301.html"
      },
      {
        "wp": "475 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-475wp-120tn-m10-topcon-gunes-paneli-1302.html"
      },
      {
        "wp": "470 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-470wp-120tn-m10-topcon-gunes-paneli-1303.html"
      },
      {
        "wp": "465 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-465wp-120tn-m10-topcon-gunes-paneli-1304.html"
      },
      {
        "wp": "460 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-460wp-120tn-m10-topcon-gunes-paneli-1305.html"
      }
    ]
  },
  {
    "title": "TommaTech 480-460Wp M10 120TNFB TopCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/152_tommatech-480-460wp-m10-120tnfb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "480 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-480wp-120tnfb-m10-topcon-dark-series-gunes-paneli-1425.html"
      },
      {
        "wp": "475 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-475wp-120tnfb-m10-topcon-dark-series-gunes-paneli-1424.html"
      },
      {
        "wp": "470 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-470wp-120tnfb-m10-topcon-dark-series-gunes-paneli-1423.html"
      },
      {
        "wp": "465 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-465wp-120tnfb-m10-topcon-dark-series-gunes-paneli-1422.html"
      },
      {
        "wp": "460 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-460wp-120tnfb-m10-topcon-dark-series-gunes-paneli-1421.html"
      }
    ]
  },
  {
    "title": "TommaTech Easy Life 15Wp Mobil Solar Şarj Paneli",
    "image": "https://cw-enerji.com/images/kategory_grup/119_tommatech-easy-life-15wp-mobil-solar-sarj-paneli.webp",
    "text": "Prizma Yüzey\nETFE ile Mükemmel Işık Geçirgenliği\nIBC Hücre Teknolojisi\nUltra Hafif\nHızlı Şarj Teknolojisi",
    "variants": [
      {
        "wp": "15 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-easy-life-15wp-mobil-solar-sarj-paneli-1313.html"
      }
    ]
  },
  {
    "title": "TommaTech Easy Life 200-150W Taşınabilir Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/205_tommatech-easy-life-200-150w-tasinabilir-gunes-panelleri.webp",
    "text": "Artırılabilir Kapasite\nTOPCon N-Type Hücre Teknolojisi\nETFE ile Mükemmel Isık Geçirgenligi\nKompakt Katlanabilir Tasınabilir\nGenis Uyumlu Konnektörler (MC4&XT60)\nKurulum Kolaylıgı ile Hızlı Kullanım\nHızlı Şarj Teknolojisi",
    "variants": [
      {
        "wp": "200 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-200w-tasinabilir-gunes-paneli-1834.html"
      },
      {
        "wp": "150 W",
        "link": "https://cw-enerji.com/tr/urun/tommatech-150w-tasinabilir-gunes-paneli-1835.html"
      }
    ]
  },
  {
    "title": "TommaTech 605-585Wp M10 144TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/118_tommatech-595-570wp-m10-144tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-144tn-m10-topcon-gunes-paneli-1798.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-144tn-m10-topcon-gunes-paneli-1797.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-144tn-m10-topcon-gunes-paneli-1625.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-144tn-m10-topcon-gunes-paneli-1308.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-144tn-m10-topcon-gunes-paneli-1309.html"
      }
    ]
  },
  {
    "title": "TommaTech 605-585Wp M10 144TNFB TOPCon Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/133_tommatech-595-570wp-m10-144tnfb-topcon-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-144tnfb-m10-topcon-dark-series-gunes-paneli-1802.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-144tnfb-m10-topcon-dark-series-gunes-paneli-1801.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-144tnfb-m10-topcon-dark-series-gunes-paneli-1626.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-144tnfb-m10-topcon-dark-series-gunes-paneli-1348.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-144tnfb-m10-topcon-dark-series-gunes-paneli-1349.html"
      }
    ]
  },
  {
    "title": "TommaTech 620-600Wp M10 144TNB TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/156_tommatech-595-570wp-m10-144tnb-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-620wp-144tnb-m10-topcon-gunes-paneli-1862.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-615wp-144tnb-m10-topcon-gunes-paneli-1861.html"
      },
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-610wp-144tnb-m10-topcon-gunes-paneli-1860.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-144tnb-m10-topcon-gunes-paneli-1754.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-144tnb-m10-topcon-gunes-paneli-1753.html"
      }
    ]
  },
  {
    "title": "TommaTech 605-585Wp M10 144TNB G2G TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/177_tommatech-595-570wp-m10-144tnb-g2g-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n​​​​​​​İki Katman Eva Lamineli Çift Cam\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-144tnb-m10-g2g-topcon-gunes-paneli-1800.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-144tnb-m10-g2g-topcon-gunes-paneli-1799.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-144tnb-m10-g2g-topcon-gunes-paneli-1636.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-144tnb-m10-g2g-topcon-gunes-paneli-1635.html"
      },
      {
        "wp": "585 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-585wp-144tnb-m10-g2g-topcon-gunes-paneli-1634.html"
      }
    ]
  },
  {
    "title": "TommaTech 170-110Wp Flexible(Esnek) Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/111_tommatech-170-110wp-flexibleesnek-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Güç Çıkışı\nDayanıklı, Sağlam Hücreler\nKolay Taşıma\nKolay Kurulum\n30° Dereceye Kadar Panel Esnekliği\n2 Yıl Ürün Garantisi",
    "variants": [
      {
        "wp": "170 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-170wp-flexibleesnek-dark-series-gunes-panelleri-1271.html"
      },
      {
        "wp": "110 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-110wp-flexibleesnek-dark-series-gunes-panelleri-1272.html"
      }
    ]
  },
  {
    "title": "TommaTech 635-615Wp M10 156TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/189_tommatech-635-615wp-m10-156tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "635 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-635wp-156tn-m10-topcon-gunes-paneli-1716.html"
      },
      {
        "wp": "630 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-630wp-156tn-m10-topcon-gunes-paneli-1715.html"
      },
      {
        "wp": "625 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-625wp-156tn-m10-topcon-gunes-paneli-1714.html"
      },
      {
        "wp": "620 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-620wp-156tn-m10-topcon-gunes-paneli-1713.html"
      },
      {
        "wp": "615 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-615wp-156tn-m10-topcon-gunes-paneli-1712.html"
      }
    ]
  },
  {
    "title": "TommaTech Easy Life 25Wp Katlanabilir Güneş Paneli",
    "image": "https://cw-enerji.com/images/kategory_grup/145_tommatech-easy-life-25wp-katlanabilir-gunes-paneli.webp",
    "text": "Prizma Yüzey\nETFE ile Mükemmel Işık Geçirgenliği\nIBC Hücre Teknolojisi\nUltra Hafif\nHızlı Şarj Teknolojisi",
    "variants": [
      {
        "wp": "25 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-easy-life-25wp-katlanabilir-gunes-paneli-1314.html"
      }
    ]
  },
  {
    "title": "TommaTech 285-40Wp 72-36TN TOPCon Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/176_tommatech-285-40wp-72-36tn-topcon-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n2 Yıl Ürün Garantisi",
    "variants": [
      {
        "wp": "285 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-285wp-72tn-topcon-gunes-paneli-1612.html"
      },
      {
        "wp": "130 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-130wp-36tn-topcon-gunes-paneli-1613.html"
      },
      {
        "wp": "120 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-120wp-36tn-topcon-gunes-paneli-1614.html"
      },
      {
        "wp": "110 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-110wp-36tn-topcon-gunes-paneli-1615.html"
      },
      {
        "wp": "100 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-100wp-36tn-topcon-gunes-paneli-1616.html"
      },
      {
        "wp": "95 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-95wp-36tn-topcon-gunes-paneli-1617.html"
      },
      {
        "wp": "85 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-85wp-36tn-topcon-gunes-paneli-1618.html"
      },
      {
        "wp": "80 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-80wp-36tn-topcon-gunes-paneli-1619.html"
      },
      {
        "wp": "70 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-70wp-36tn-topcon-gunes-paneli-1620.html"
      },
      {
        "wp": "65 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-65wp-36tn-topcon-gunes-paneli-1621.html"
      },
      {
        "wp": "55 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-55wp-36tn-topcon-gunes-paneli-1622.html"
      },
      {
        "wp": "45 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-45wp-36tn-topcon-gunes-paneli-1623.html"
      },
      {
        "wp": "40 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-40wp-36tn-topcon-gunes-paneli-1624.html"
      }
    ]
  },
  {
    "title": "TommaTech 675-650Wp M12 132PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/50_tommatech-675-650wp-m12-132pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-675wp-132pmb-m12-hc-mb-g2g-gunes-paneli-746.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-670wp-132pmb-m12-hc-mb-g2g-gunes-paneli-747.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-665wp-132pmb-m12-hc-mb-g2g-gunes-paneli-748.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-660wp-132pmb-m12-hc-mb-g2g-gunes-paneli-749.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-655wp-132pmb-m12-hc-mb-g2g-gunes-paneli-750.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-650wp-132pmb-m12-hc-mb-g2g-gunes-paneli-751.html"
      }
    ]
  },
  {
    "title": "TommaTech 675-650Wp M12 132PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/49_tommatech-675-650wp-m12-132pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-675wp-132pm-m12-hc-mb-gunes-paneli-735.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-670wp-132pm-m12-hc-mb-gunes-paneli-736.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-665wp-132pm-m12-hc-mb-gunes-paneli-737.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-660wp-132pm-m12-hc-mb-gunes-paneli-738.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-655wp-132pm-m12-hc-mb-gunes-paneli-739.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-650wp-132pm-m12-hc-mb-gunes-paneli-740.html"
      }
    ]
  },
  {
    "title": "TommaTech 610-590Wp M12 120PMB G2G HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/47_tommatech-610-590wp-m12-120pmb-g2g-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nKendi Kendini Temizleyen Ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-610wp-120pmb-m12-hc-mb-g2g-gunes-paneli-741.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-120pmb-m12-hc-mb-g2g-gunes-paneli-742.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-120pmb-m12-hc-mb-g2g-gunes-paneli-743.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-120pmb-m12-hc-mb-g2g-gunes-paneli-744.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-120pmb-m12-hc-mb-g2g-gunes-paneli-745.html"
      }
    ]
  },
  {
    "title": "TommaTech 610-590Wp M12 120PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/61_tommatech-610-590wp-m12-120pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-610wp-120pmb-m12-hc-mb-gunes-paneli-1151.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-120pmb-m12-hc-mb-gunes-paneli-1152.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-120pmb-m12-hc-mb-gunes-paneli-1153.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-120pmb-m12-hc-mb-gunes-paneli-1154.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-120pmb-m12-hc-mb-gunes-paneli-1155.html"
      }
    ]
  },
  {
    "title": "TommaTech 610-590Wp M12 120PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/46_tommatech-610-590wp-m12-120pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-610wp-120pm-m12-hc-mb-gunes-paneli-730.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-120pm-m12-hc-mb-gunes-paneli-731.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-120pm-m12-hc-mb-gunes-paneli-732.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-120pm-m12-hc-mb-gunes-paneli-733.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-120pm-m12-hc-mb-gunes-paneli-734.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M12 108PMB HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/42_tommatech-550-530wp-m12-108pmb-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-108pmb-m12-hc-mb-gunes-paneli-1195.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-108pmb-m12-hc-mb-gunes-paneli-1194.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-108pmb-m12-hc-mb-gunes-paneli-1193.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-108pmb-m12-hc-mb-gunes-paneli-1192.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-108pmb-m12-hc-mb-gunes-paneli-1191.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M12 108 PM HC MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/1_tommatech-550-530wp-m12-108-pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nToz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-108pm-m12-hc-mb-gunes-paneli-826.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-108pm-m12-hc-mb-gunes-paneli-827.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-108pm-m12-hc-mb-gunes-paneli-828.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-108pm-m12-hc-mb-gunes-paneli-829.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-108pm-m12-hc-mb-gunes-paneli-830.html"
      }
    ]
  },
  {
    "title": "TommaTech 410-390Wp M12 120PM TC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/45_tommatech-410-390wp-m12-120pm-tc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Malzeme\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "410 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-410wp-120pm-m12-tc-mb-gunes-paneli-816.html"
      },
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-120pm-m12-tc-mb-gunes-paneli-817.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-120pm-m12-tc-mb-gunes-paneli-818.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-120pm-m12-tc-mb-gunes-paneli-819.html"
      },
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-390wp-120pm-m12-tc-mb-gunes-paneli-820.html"
      }
    ]
  },
  {
    "title": "TommaTech 405-385Wp M12 120PM-F TC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/44_tommatech-405-385wp-m12-120pm-f-tc-mb-gunes-paneli-serisi.webp",
    "text": "Multi Busbar Teknolojisi\nOn-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-120pm-f-m12-tc-mb-gunes-paneli-900.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-120pm-f-m12-tc-mb-gunes-paneli-899.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-120pm-f-m12-tc-mb-gunes-paneli-898.html"
      },
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-390wp-120pm-f-m12-tc-mb-gunes-paneli-895.html"
      },
      {
        "wp": "385 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-385wp-120pm-f-m12-tc-mb-gunes-paneli-896.html"
      }
    ]
  },
  {
    "title": "TommaTech 405-385Wp M12 80PM-F TC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/40_tommatech-405-385wp-m12-80pm-f-tc-mb-gunes-paneli-serisi.webp",
    "text": "Multi Busbar Teknolojisi\nOn-grid ve Off-grid Çalışabilme\nYüksek Dönüşüm Verimliliği\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "405 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-405wp-80pm-f-m12-tc-mb-gunes-paneli-886.html"
      },
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-80pm-f-m12-tc-mb-gunes-paneli-885.html"
      },
      {
        "wp": "395 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-395wp-80pm-f-m12-tc-mb-gunes-paneli-884.html"
      },
      {
        "wp": "390 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-390wp-80pm-f-m12-tc-mb-gunes-paneli-883.html"
      },
      {
        "wp": "385 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-385wp-80pm-f-m12-tc-mb-gunes-paneli-882.html"
      }
    ]
  },
  {
    "title": "TommaTech 240-45Wp M12 48-36PM HC-MB Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/62_tommatech-240-45wp-m12-48-36pm-hc-mb-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\n2 Yıl Ürün Garantisi",
    "variants": [
      {
        "wp": "240 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-240wp-48pm-m12-hc-mb-gunes-paneli-1211.html"
      },
      {
        "wp": "120 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-120wp-m12-36pm-hc-mb-gunes-paneli-1252.html"
      },
      {
        "wp": "90 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-90wp-m12-36pm-hc-mb-gunes-paneli-1429.html"
      },
      {
        "wp": "60 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-60wp-m12-36pm-hc-mb-gunes-paneli-1430.html"
      },
      {
        "wp": "45 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-45wp-m12-36pm-hc-mb-gunes-paneli-1445.html"
      }
    ]
  },
  {
    "title": "TommaTech Easy Life 110Wp Katlanabilir Güneş Paneli",
    "image": "https://cw-enerji.com/images/kategory_grup/72_tommatech-easy-life-110wp-katlanabilir-gunes-paneli.webp",
    "text": "Prizma Yüzey\nETFE ile Mükemmel Işık Geçirgenliği\nIBC Hücre Teknolojisi\nUltra Hafif Kullanımı\nKolay Arttırılabilir Kapasite",
    "variants": [
      {
        "wp": "110 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-easy-life-110wp-katlanabilir-gunes-paneli-1221.html"
      }
    ]
  },
  {
    "title": "TommaTech Easy Life Mobil Solar Şarj Paneli Omuz Askısı",
    "image": "https://cw-enerji.com/images/kategory_grup/76_tommatech-easy-life-mobil-solar-sarj-paneli-omuz-askisi.webp",
    "text": "Estetik ve Şık Askı\nTommaTech Easy Life Mobil Solar Şarj Panellerinin Tamamlayıcı,\nVazgeçilmez Aksesuarı",
    "variants": [
      {
        "wp": "0 Aksesuar",
        "link": "https://cw-enerji.com/tr/urun/tommatech-easy-life-mobil-solar-sarj-paneli-omuz-askisi-717.html"
      }
    ]
  },
  {
    "title": "TommaTech 170-110Wp Flexible(Esnek) Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/65_tommatech-170-55wp-flexibleesnek-gunes-paneli-serisi.webp",
    "text": "Yüksek Güç Çıkışı\nDayanıklı, Sağlam Hücreler\nKolay Taşıma\nKolay Kurulum\n30° Dereceye Kadar Panel Esnekliği\n2 Yıl Ürün Garantisi",
    "variants": [
      {
        "wp": "170 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-170wp-flexibleesnek-gunes-paneli-137.html"
      },
      {
        "wp": "110 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-110wp-flexibleesnek-gunes-paneli-136.html"
      }
    ]
  },
  {
    "title": "TommaTech 675-650Wp M12 132 PM HC MB Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/51_tommatech-675-650wp-m12-132-pm-hc-mb-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Malzeme Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "675 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-675wp-132pm-m12-dark-series-gunes-paneli-1026.html"
      },
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-670wp-132pm-m12-dark-series-gunes-paneli-1025.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-665wp-132pm-m12-dark-series-gunes-paneli-1024.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-660wp-132pm-m12-dark-series-gunes-paneli-1021.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-655wp-132pm-m12-dark-series-gunes-paneli-1020.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-650wp-132pm-m12-dark-series-gunes-paneli-1019.html"
      }
    ]
  },
  {
    "title": "TommaTech 610-590Wp M12 120PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/48_tommatech-610-590wp-m12-120pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Malzeme Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "610 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-610wp-120pm-m12-dark-series-gunes-paneli-1017.html"
      },
      {
        "wp": "605 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-605wp-120pm-m12-dark-series-gunes-paneli-1016.html"
      },
      {
        "wp": "600 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-600wp-120pm-m12-dark-series-gunes-paneli-1014.html"
      },
      {
        "wp": "595 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-595wp-120pm-m12-dark-series-gunes-paneli-1013.html"
      },
      {
        "wp": "590 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-590wp-120pm-m12-dark-series-gunes-paneli-1011.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M12 108PM Dark Series Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/43_tommatech-530-550wp-m12-108pm-dark-series-gunes-panelleri.webp",
    "text": "Yüksek Panel Verimliliği\nÖzel Kaplamalı, Toz Tutmayan ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Malzeme Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-108pm-m12-dark-series-gunes-paneli-1010.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-108pm-m12-dark-series-gunes-paneli-1008.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-108pm-m12-dark-series-gunes-paneli-1007.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-108pm-m12-dark-series-gunes-paneli-1005.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-108pm-m12-dark-series-gunes-paneli-1003.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M12 108PM HC-MB Çatı Kiremidi Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/66_tommatech-550-530wp-m12-108pm-hc-mb-cati-kiremidi-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-108pm-m12-hc-mb-cati-kiremidi-1206.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-108pm-m12-hc-mb-cati-kiremidi-1205.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-108pm-m12-hc-mb-cati-kiremidi-1204.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-108pm-m12-hc-mb-cati-kiremidi-1203.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-108pm-m12-hc-mb-cati-kiremidi-1199.html"
      }
    ]
  },
  {
    "title": "TommaTech 400-240Wp BIPV Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/68_tommatech-400-240wp-bipv-gunes-panelleri.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5Wp Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n30 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "400 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-400wp-80pm-g2g-250m-teras-gunes-paneli-1043.html"
      },
      {
        "wp": "320 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-320wp-64pm-g2g-200m-teras-gunes-paneli-1044.html"
      },
      {
        "wp": "240 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-240wp-48pm-g2g-175m-teras-gunes-paneli-1045.html"
      },
      {
        "wp": "240 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-240wp-48pm-g2g-150m-teras-gunes-paneli-1046.html"
      }
    ]
  },
  {
    "title": "TommaTech 550-530Wp M10 144PM Black&White Güneş Paneli Serisi",
    "image": "https://cw-enerji.com/images/kategory_grup/191_tommatech-550-530wp-m10-144pm-blackwhite-gunes-paneli-serisi.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "550 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-550wp-144pm-m10-blackwhite-gunes-paneli-1776.html"
      },
      {
        "wp": "545 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-545wp-144pm-m10-blackwhite-gunes-paneli-1777.html"
      },
      {
        "wp": "540 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-540wp-144pm-m10-blackwhite-gunes-paneli-1778.html"
      },
      {
        "wp": "535 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-535wp-144pm-m10-blackwhite-gunes-paneli-1779.html"
      },
      {
        "wp": "530 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-530wp-144pm-m10-blackwhite-gunes-paneli-1780.html"
      }
    ]
  },
  {
    "title": "TommaTech 670-645Wp M12 108PMB Diamond Plus Güneş Panelleri",
    "image": "https://cw-enerji.com/images/kategory_grup/203_tommatech-655-625wp-m12-108pmb-diamond-plus-gunes-panelleri.webp",
    "text": "Arka Yüzey Güç Kazanımı ile Maksimum Güç: 670-645Wp\nÖn Yüzeyden Elde Edilen Maksimum Güç: 570-545Wp\nYüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımla Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "670 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-670wp-108pmb-m12-diamond-plus-gunes-paneli-1823.html"
      },
      {
        "wp": "665 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-665wp-108pmb-m12-diamond-plus-gunes-paneli-1822.html"
      },
      {
        "wp": "660 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-660wp-108pmb-m12-diamond-plus-gunes-paneli-1821.html"
      },
      {
        "wp": "655 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-655wp-108pmb-m12-diamond-plus-gunes-paneli-1820.html"
      },
      {
        "wp": "650 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-650wp-108pmb-m12-diamond-plus-gunes-paneli-1825.html"
      },
      {
        "wp": "645 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-645wp-108pmb-m12-diamond-plus-gunes-paneli-1824.html"
      }
    ]
  },
  {
    "title": "TommaTech 720-690Wp 144TNB M10 Diamond Plus Güneş Paneli",
    "image": "https://cw-enerji.com/images/kategory_grup/204_tommatech-720-690wp-144tnb-m10-diamond-plus-gunes-paneli.webp",
    "text": "Arka Yüzey Güç Kazanımı ile Maksimum Güç: 720-690Wp\nÖn Yüzeyden Elde Edilen Maksimum Güç: 605-585Wp\nYüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımla Yüksek Verimlilik\nKolay Kurulum\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": [
      {
        "wp": "720 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-720wp-144tnb-m10-diamond-plus-gunes-paneli-1833.html"
      },
      {
        "wp": "715 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-715wp-144tnb-m10-diamond-plus-gunes-paneli-1827.html"
      },
      {
        "wp": "710 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-710wp-144tnb-m10-diamond-plus-gunes-paneli-1828.html"
      },
      {
        "wp": "705 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-705wp-144tnb-m10-diamond-plus-gunes-paneli-1829.html"
      },
      {
        "wp": "700 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-700wp-144tnb-m10-diamond-plus-gunes-paneli-1830.html"
      },
      {
        "wp": "695 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-695wp-144tnb-m10-diamond-plus-gunes-paneli-1831.html"
      },
      {
        "wp": "690 Wp",
        "link": "https://cw-enerji.com/tr/urun/tommatech-690wp-144tnb-m10-diamond-plus-gunes-paneli-1832.html"
      }
    ]
  },
  {
    "title": "CW Enerji 455Wp 108TNB M10 G2G TopCon Güneş Paneli",
    "image": "https://cw-enerji.com/images/product/1903_cw-enerji-455wp-108tnb-m10-g2g-topcon-gunes-paneli_0.jpg",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n12 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech 615Wp 120TNB M12 G2G Topcon Güneş Paneli",
    "image": "https://cw-enerji.com/images/product/1947_tommatech-615wp-120tnb-m12-g2g-topcon-gunes-paneli_0.webp",
    "text": "Yüksek Dönüşüm Verimliliği\nKendi Kendini Temizleyen ve Yansımayı Azaltan Cam\nDüşük Işınımda Yüksek Verimlilik\nMükemmel Dayanım Kapasitesi\n0~+5W Pozitif Güç Toleransı\nKolay Kurulum\nİki Katman Eva Lamineli Çift Cam\n15 Yıl Ürün Garantisi\n30 Yıl Performans Garantisi",
    "variants": []
  }
];

export default paneller;
